<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="m-portlet">

          <div class="m-portlet__head">

            <div class="row md-h-100">
              <div class="col-sm-12 col-md-auto md-align" style="height: 100%;"><h4>Reports</h4></div>
              <div class="col-sm-12 col-md md-align" style="height: 100%;">
                <div class="row">
                  <div class="col-md col-sm-12 mt-1">
                    <invoice-generator></invoice-generator>
                  </div>
                  <div class="col-md col-sm-12 mt-1 mb-1">
                    <date-range-picker
                      opens="left"
                      :startDate="startDate"
                      :endDate="endDate"
                      @update="onDateRangeSelected"
                    ></date-range-picker>
                  </div>
                </div>
              </div>
            </div>


            <!--<div class="m-portlet__head-caption">-->
            <!--<div class="m-portlet__head-title">-->
            <!--<span class="m-portlet__head-icon m&#45;&#45;hide">-->
            <!--<i class="la la-gear"></i>-->
            <!--</span>-->
            <!--<h3 class="m-portlet__head-text">-->
            <!--Reports-->
            <!--</h3>-->
            <!--</div>-->
            <!--</div>-->

            <!--<div class="m-portlet__head-tools">-->
            <!--<div class="col text-right align-self-center pr-0">-->
            <!--<div class="row">-->
            <!--<div class="col-10 invoice-generator-wrapper">-->
            <!--<invoice-generator></invoice-generator>-->
            <!--</div>-->
            <!--<div class="col-2">-->
            <!--<date-range-picker-->
            <!--opens="left"-->
            <!--:startDate="startDate"-->
            <!--:endDate="endDate"-->
            <!--@update="onDateRangeSelected"-->
            <!--&gt;</date-range-picker>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
          </div>
        </div>
      </div>
    </div>

    <targets :startDate="formattedStartDate" :endDate="formattedEndDate"></targets>
    <top-client-managers :startDate="formattedStartDate" :endDate="formattedEndDate"></top-client-managers>
    <overall-performance :startDate="formattedStartDate" :endDate="formattedEndDate"></overall-performance>
    <top-resource :startDate="formattedStartDate" :endDate="formattedEndDate"></top-resource>
    <resource-financial :startDate="formattedStartDate" :endDate="formattedEndDate"></resource-financial>
    <top-clients :startDate="formattedStartDate" :endDate="formattedEndDate"></top-clients>
    <top-managers :startDate="formattedStartDate" :endDate="formattedEndDate"></top-managers>
  </div>
</template>

<script>
  import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'

  import TopClients from './TopClients.vue'
  import TopManagers from './TopManagers.vue'
  import TopResource from './TopResources.vue'
  import OverallPerformance from './OverallPerformance.vue'
  import InvoiceGenerator from './InvoiceGenerator.vue'
  import ResourceFinancial from './ResourceFinancial'
  import TopClientManagers from './TopClientManagers.vue'
  import Targets from './Targets.vue'

  export default {
    components: {
      DateRangePicker,
      TopClients,
      TopManagers,
      TopResource,
      OverallPerformance,
      InvoiceGenerator,
      ResourceFinancial,
      TopClientManagers,
      Targets,
    },

    data() {
      return {
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month')
      }
    },

    computed: {
      formattedStartDate() {
        return this.startDate.format('YYYY-MM-DD')
      },
      formattedEndDate() {
        return this.endDate.format('YYYY-MM-DD')
      }
    },

    methods: {
      onDateRangeSelected(dateRange) {
        this.startDate = moment(dateRange.startDate)
        this.endDate = moment(dateRange.endDate)
      },
    }
  }
</script>

<style lang="scss">
  .invoice-generator-wrapper {
    display: flex;
    align-items: center;
  }

  .daterangepicker .applyBtn {
    background-color: #8C96E8;

    margin-bottom: 10px !important;
    margin-left: 0px !important;

  }

  .daterangepicker .ranges {
    padding-top: 0 !important;
    margin-top: 0 !important;
  }

  .daterangepicker .range_inputs {
    margin-top: 0;
  }

  .light-hover:hover {
    background: #fafafa;
  }

  @media (min-width: 576px) {
    .md-h-100 {
      height: 100%;
    }
    .md-align {
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
  @media (max-width: 576px) {
    .daterangepicker.opensleft {
      width: 100vw;
      left: -40px !important;
      right: auto !important;


      .calendar.right.hidden-xs {
        display: none !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/reports/Index.vue